(() => {
  const initAnnouncements = (root = document) => {
    root.querySelectorAll('.pansaar-announcement[data-rotate="true"]').forEach((bar) => {
      if (bar.dataset.initialized === 'true') return;
      bar.dataset.initialized = 'true';
      const track = bar.querySelector('.pansaar-announcement__inner');
      const items = [...bar.querySelectorAll('.pansaar-announcement__item')];
      const delay = Math.max(3000, Number(bar.dataset.delay || 5000));
      if (!track || items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let index = 0;
      let timer;
      const start = () => {
        stop();
        timer = setInterval(() => {
          index = (index + 1) % items.length;
          track.style.transform = `translateX(-${index * 100}%)`;
        }, delay);
      };
      const stop = () => timer && clearInterval(timer);
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);
      start();
    });
  };

  const initSmartHeader = (root = document) => {
    const header = root.querySelector?.('.header-section') || document.querySelector('.header-section');
    if (!header || header.dataset.pansaarSmartHeader === 'true') return;
    header.dataset.pansaarSmartHeader = 'true';
    let lastY = window.scrollY;
    let direction = 'up';
    let ticking = false;

    const update = () => {
      const y = Math.max(0, window.scrollY);
      const pastHeader = y > 140;
      header.classList.toggle('pansaar-header--compact', pastHeader);

      if (!pastHeader) {
        header.classList.remove('pansaar-header--hidden');
      } else {
        header.classList.toggle('pansaar-header--hidden', direction === 'down');
      }

      ticking = false;
    };

    window.addEventListener('scroll', () => {
      const y = Math.max(0, window.scrollY);
      if (Math.abs(y - lastY) > 6) direction = y > lastY ? 'down' : 'up';
      lastY = y;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  };

  const init = (root = document) => {
    initAnnouncements(root);
    initSmartHeader(root);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
